import React from "react";
import { Link } from "../../utils/customLink";

const TextExtraCTA = ({
  btnTarget,
  btnLabel,
  containerClass = "relative flex items-center justify-center px-4 md:px-0 bg-yellow-lighter dark:bg-gray-darker overflow-hidden",
  ctaContainerClass = "w-11/12 md:w-9/12 mx-auto pt-5 pb-20 flex justify-center items-center",
  ctaButtonClass = "block md:my-7 px-7 py-2 submit-button w-full md:w-52"
}) => {
  return (
    <section className={containerClass}>
      <div className={ctaContainerClass}>
        <Link className={ctaButtonClass} to={btnTarget}>
          {btnLabel}
        </Link>
      </div>
    </section>
  );
};

export default TextExtraCTA;
